import type { ReactNode } from 'react';

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'planned';

export interface StatusBadgeProps {
  readonly tone?: StatusTone;
  readonly children: ReactNode;
  readonly title?: string;
}

export function StatusBadge({ tone = 'neutral', children, title }: StatusBadgeProps) {
  return (
    <span className={`cap-badge cap-badge--${tone}`} data-tone={tone} title={title}>
      {children}
    </span>
  );
}
